import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { Console } from '@angular/core/src/console';

@Injectable()
export class RecepcionApiService {


  data: any[] = [];

  recepcionURL: string = config.API_DATA_URL + '/recepcion';

  constructor(public http: HttpClient) {}

  public getRecepcionData(idOS: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.recepcionURL + '/GetRecepcion/' + idOS, { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public getDatosImpresion(idOS: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.recepcionURL + '/GetDatosImpresion/' + idOS, { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public getArchivos(idOS: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.recepcionURL + '/GetArchivos/' + idOS + '/A', { headers })
    .map( (response: any) => {
        this.data = response;
        return this.data;
      })
    .catch(this.handleError)
  }

  public RecibirUnidad(recepcion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(recepcion);
    // console.log(param);
    return this.http.post(this.recepcionURL + '/RecibirUnidad', param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(error);
      });
  }

  public SeleccionLlanta(llanta: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(llanta);
    // console.log(param);
    return this.http.post(this.recepcionURL + '/SeleccionLlanta', param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(error);
      });
  }

  public QuitarLlanta(llanta: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(llanta);
    // console.log(param);
    return this.http.post(this.recepcionURL + '/QuitarLlanta', param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(error);
      });
  }

  public ActualizarUnidad(id: number, recepcion: any)  {
    const headers = this.getHeaders();
    const param = JSON.stringify(recepcion);
    // console.log(param);
    return this.http.put(this.recepcionURL + '/' + id, param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(error);
      });
  }

  public AceptarRecepcion(id: number)  {
    const headers = this.getHeaders();
    
    return this.http.post(this.recepcionURL + '/AceptarRecepcion/' + id, null, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(error);
      });
  }

  public EstadoUnidad(estado: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(estado);
    // console.log(param);
    return this.http.post(this.recepcionURL + '/EstadoUnidad', param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  public EliminarFoto(terminada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(terminada);
    // console.log(param);
    return this.http.post(this.recepcionURL + '/EliminarFoto', param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/recepcion-api.service.ts